var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[_c('pre-loader')],1),_c('header-ele'),_c('intro-sec'),_c('background-sec'),_c('about-me-sec'),_c('projects-sec'),_c('resume-sec'),_c('back-top-btn'),_c('footer-ele')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }